import React, { useState } from 'react';
import { siteConfig } from '../../config/siteConfig';
import NewsletterModal from '../NewsletterModal/NewsletterModal';
import './NewsletterBanner.css';

const NewsletterBanner = () => {
  const { newsletterBanner } = siteConfig;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubscribe = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section 
        className="newsletter-banner"
        style={{ 
          backgroundColor: newsletterBanner.backgroundColor,
          color: newsletterBanner.textColor 
        }}
      >
        <div className="newsletter-banner-content">
          <div className="newsletter-scrolling-container">
            <div className="newsletter-line newsletter-line-1">
              <div className="scrolling-text newsletter-line-out1" data-speed={newsletterBanner.scrollingSpeed.titleLine}>
                <span className="newsletter-line-1-text">
                  {Array(30).fill(null).map((_, index) => (
                    <span key={index} className={index === 3 ? 'solid' : 'outline'}>
                      {newsletterBanner.title}&nbsp;
                    </span>
                  ))}
                </span>
              </div>
            </div>
            <div className="newsletter-line newsletter-line-2">
              <div className="scrolling-text newsletter-line-out2" data-speed={newsletterBanner.scrollingSpeed.subtitleLine}>
                <span className="newsletter-line-2-text">
                  {Array(28).fill(null).map((_, index) => (
                    <span key={index} className={index === 2 ? 'solid' : 'outline'}>
                      {newsletterBanner.subtitle}&nbsp;
                    </span>
                  ))}
                </span>
              </div>
            </div>
          </div>
          <div className="newsletter-banner-content-right">
            <img 
              src={newsletterBanner.buttonIcon.src} 
              alt={newsletterBanner.buttonIcon.alt} 
              className="newsletter-button-icon"
            />
            <button 
              className="newsletter-button"
              onClick={handleSubscribe}
            >
              {newsletterBanner.buttonText}
            </button>
          </div>
        </div>
      </section>
      
      <NewsletterModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
      />
    </>
  );
};

export default NewsletterBanner; 